import { getSignificantDigitCount } from '../../../../utils/forms/inputs/getSignificantDigitCount';
import { hasTooManyDigits } from '../../../../utils/forms/inputs/hasTooManyDigits';
import { keepSingleDecimalSeparator } from '../../../../utils/forms/inputs/keepSingleDecimalSeparator';

// Mirrors the while-typing sanitization of the form NumberInput so numeric
// entry error inputs behave the same: disallowed characters never appear,
// float keeps a single decimal separator (the last typed one wins) and input
// growing past the safe significant-digit limit is ignored.
export const sanitizeEntryNumericValue = (
  valueType: 'int' | 'float',
  inputValue: string,
  previousValue: string,
  cursorPosition?: number
): string => {
  const sanitized =
    valueType === 'float'
      ? keepSingleDecimalSeparator(inputValue, cursorPosition).replace(
          /[^0-9-.,]+/g,
          ''
        )
      : inputValue.replace(/[^0-9-]+/g, '').replace(/^(-?)0+(\d)/, '$1$2');

  if (
    getSignificantDigitCount(sanitized) >
      getSignificantDigitCount(previousValue) &&
    hasTooManyDigits(sanitized)
  ) {
    return previousValue;
  }

  return sanitized;
};
